import { useSelector } from 'react-redux';

export const useHasSession = () => {
  const portalUserList = useSelector((state) => state?.tempEdge?.login?.portalUserList);
  const hasSessionFromState = portalUserList?.[0]?.status === 'A';
  const hasToken = !!localStorage.getItem('access_token');
  const hasAgency = !!localStorage.getItem('agency_validated') || !!localStorage.getItem('agency');

  return hasSessionFromState || (hasToken && hasAgency);
};

export default useHasSession;
